export default __webpack_public_path__ + "static/media/calc.2e39c324.png";